export const BoxFlexibilityAwarenessTexts = {
  title: 'Hassle-free cancellation',
  subTitle: 'No minimum contract: skip a box or cancel your subscription online, any time',
}
